interface Props {
  svg: string;
}

const TenantIconSvg = ({ svg }: Props) => (
  <img
    src={`data:image/svg+xml;utf8,${encodeURIComponent(svg)}`}
    alt=""
    style={{ width: "auto", maxHeight: "30px" }}
  />
);

export default TenantIconSvg;
